import PropTypes from 'prop-types'
import React, { Component } from 'react'

class Links extends Component {
  constructor(props) {
    super(props)
    this.state = {
      checkBoxErrors: {},
    }
  }

  decodeHtml(html) {
    const txt = document.createElement('textarea')
    txt.innerHTML = html
    return txt.value
  }

  render() {
    return (
      <div className="brumbrum-link">
        {this.props.links.map((link, i) => (
          <div key={i}>
            <a
              href={link.href}
              rel="noreferrer"
              target={'_blank'}
              title={link.title}
            >
              {this.decodeHtml(link.text)}
            </a>
          </div>
        ))}
      </div>
    )
  }
}

Links.propTypes = {
  links: PropTypes.array.isRequired,
}

export default Links
